import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: environment.cognitoDomain.replace('https://', ''), // Solo el dominio sin https://
          redirectSignIn: [window.location.origin + '/callback'],
          redirectSignOut: [window.location.origin + '/'],
          responseType: 'code',
          scopes: ['email', 'openid', 'phone', 'profile']
        }
      }
    }
  },
  API: {
    GraphQL: {
      endpoint: environment.notificationsEndpoint,
      region: environment.cognito.region,
      defaultAuthMode: 'userPool', // Cambiar de 'apiKey' a 'userPool'
      apiKey: 'da2-bux7vayyyvfsjixw45mfveegw4' // Mantener para fallback
    },
    Events: {
      endpoint:
        'https://om7cbubwefhtfdw7ldgnhizt74.appsync-api.us-east-2.amazonaws.com/event',
      region: 'us-east-2',
      defaultAuthMode: 'userPool', // Cambiar de 'apiKey' a 'userPool'
      apiKey: 'da2-74ea35w2bve73bkqccc75tfn2u' // Mantener para fallback
    }
  }
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
